<template>
    <CustomCallout
      :opened="true"
      class="mb-3"
    >
        <div>
            <small class="title__label">Impedimento:</small>
            <p class="title__text">{{ title }}</p>
        </div>
        
        <template #edition>
            <div class="impediment__container">
                <slot></slot>
            </div>
        </template>
    </CustomCallout>
</template>
  
<script>
import CustomCallout from 'custom-callout';

export default {
    name: 'ImpedimentContainer',
    components: {
        CustomCallout
    },
    props: {
        title: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
        }
    },
    computed: {
    },
    watch: {
    },
    mounted() {}
}
</script>

<style scoped>
.impediment__container {
    padding: 20px 30px;
}

.title__label {
    color: #727272;
}

.title__text {
    font-weight: bold;
}
</style>